import React, { useEffect, useState, useContext } from 'react';
import styles from './Import.module.css';
import lineTableItems from '../../assets/line_table_items.svg';
import ArrowBelow from '../../assets/arrow_below.svg';

import { getStoresFromDatabase } from "../../hooks/Store";
import { getProductsByStore } from "../../hooks/Product";
import { TemplateContext } from '../../context/TemplateContext';
import { ProductContext } from '../../context/ProductContext';
import { StoresContext } from '../../context/StoresContext';

import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

const Import = () => {

    const { 
        isCreatedTemplate,
        clearSuccess
     } = useContext(TemplateContext);

     const { 
        setStore
     } = useContext(StoresContext);

    const { 
        setProduct, 
        isEditedProduct,
        isCreatedProduct,
        isDeletedProduct,
        clearProduct,
        setProductIds,
        researchProducts
    } = useContext(ProductContext);

    const [stores, setStores] = useState([]);
    const [products, setProducts] = useState([]);
    const [selectedStoreId, setSelectedStoredId] = useState(null);
    const [selectedProducts, setSelectedProducts] = useState([]);
    const [selectAll, setSelectAll] = useState(false);

    const [currentPage, setCurrentPage] = useState(1);
    const [itemsPerPage] = useState(50);
    const [totalItems, setTotalItems] = useState(0);

    useEffect(() => {
        fetchStores();
    },[]);


    useEffect(() => {
        if(researchProducts !== undefined && researchProducts?.length > 0) {
            setProducts(researchProducts)
        }else {
            fetchProductsByStoreId(selectedStoreId, currentPage, itemsPerPage);
        }
      
    },[researchProducts])


    const fetchStores = async () => {
        try {
            const storeData = await getStoresFromDatabase();
            if (storeData) {
                setStores(storeData.data.stores);
            }
        }catch(err) {
            console.error("Error to search stores:", err);
        }
    };


    useEffect(() => {
        if (selectedStoreId) {
            fetchProductsByStoreId(selectedStoreId, currentPage, itemsPerPage);
        }
    }, [selectedStoreId, currentPage]);


    const fetchProductsByStoreId = async (storeId, page, limit) => {
        try {
            const productData = await getProductsByStore(storeId, page, limit);
            if (productData) {
                setProducts(productData.data.products);
                setTotalItems(productData.data.totalItems || 0);
            } else {
                setProducts([]);
            }
        } catch (error) {
            console.error("Erro ao buscar produtos:", error);
            setProducts([]);
        }
    };


    useEffect(() => {
        if (isCreatedTemplate !== null) {
            if (isCreatedTemplate) {
                alert("Template de importação de produtos salvo com sucesso.");
            }
            clearSuccess();
        }
    }, [isCreatedTemplate]);


    useEffect(() => {
        if (isCreatedProduct !== null) {
            if (isCreatedProduct) {
                toast.success("Produto salvo com sucesso.");

                if (selectedStoreId) {
                    fetchProductsByStoreId(selectedStoreId, currentPage, itemsPerPage);
                }
            }
            clearProduct();
        }
    }, [isCreatedProduct, clearProduct]);


    useEffect(() => {
        if (isEditedProduct !== null) {
            if (isEditedProduct) {
                toast.success("Produto editado com sucesso.");

                if (selectedStoreId) {
                    fetchProductsByStoreId(selectedStoreId, currentPage, itemsPerPage);
                }
            }
            clearProduct();
        }
    }, [isEditedProduct, clearProduct]);


    useEffect(() => {
        if (isDeletedProduct !== null) {
            if (isDeletedProduct) {
                toast.success("Produto(s) deletado(s) com sucesso.");
                if (selectedStoreId) {
                    fetchProductsByStoreId(selectedStoreId, currentPage, itemsPerPage);
                }
            }
            clearProduct();
        }
    }, [isDeletedProduct, clearProduct]);


    const handleStoreChange = (event) => {
        const storeId = event.target.value;
        setSelectedStoredId(storeId);

        const selectedStore = stores.find(store => store.id === Number(storeId));
        setStore(selectedStore); 
    };


    const handleCheckboxChange = ( productId ) => {
        setSelectedProducts((prevSelected) => {
            const updatedSelected = prevSelected.includes(productId)
                ? prevSelected.filter((id) => id !== productId)
                : [...prevSelected, productId];
            setProduct(products.filter((product) => updatedSelected.includes(product.id)));
            setProductIds(updatedSelected);
            return updatedSelected;
        });
    };


    const handleSelectAll = () => {
        const updatedSelected = selectAll ? [] : products.map((product) => product.id);
        setProduct(products.filter((product) => updatedSelected.includes(product.id)));
        setSelectedProducts(updatedSelected);
        setProductIds(updatedSelected);
        setSelectAll(!selectAll);
    };


    const handlePreviousPage = () => {
        setCurrentPage((prev) => Math.max(prev - 1, 1));
    };


    const handleNextPage = () => {
        setCurrentPage((prev) => Math.min(prev + 1, Math.ceil(totalItems / itemsPerPage)));
    };


    return (
        <div className={styles.container}>
            <ToastContainer />
            <div className={styles.infoLine}>
                
                <div className={styles.infoLineHead}>
                    <img src={ArrowBelow} alt="Seta para baixo" />
                    <h4 className={styles.headerInfo}>Tabela de Produtos</h4>
                </div>  

                <div className={styles.infoLineSelected}>
                    <select className={styles.storeDropdown} onChange={ handleStoreChange }>
                        <option value="" disabled selected>Selecione uma loja</option>
                        {stores.map((store) => (
                            <option key={store.id} value={store.id}>{store.name}</option>
                        ))}
                    </select>

                    <div className={styles.pagination}>
                        <button onClick={handlePreviousPage} disabled={currentPage === 1}>
                            {"<"}
                        </button>
                        <span>
                            {(currentPage - 1) * itemsPerPage + 1}-{Math.min(currentPage * itemsPerPage, totalItems)} de {totalItems}
                        </span>
                        <button onClick={handleNextPage} disabled={currentPage === Math.ceil(totalItems / itemsPerPage)}>
                            {">"}
                        </button>
                    </div>

                </div>


            </div>

            
            <div className={styles.tableItems}>
            <table>
                <thead>
                    <tr>
                        {(products?.length > 0) ? (
                            <th>
                                <div className={styles.scrollableHeader}>
                                    <input
                                        type="checkbox"
                                        checked={ selectAll }
                                        onChange={ handleSelectAll }
                                    />
                                </div>
                            </th>
                        ) : <th></th>}

                        <th><div className={styles.scrollableHeader}>N° Linha</div></th>
                        <th><div className={styles.scrollableHeader}>Código de Barras</div></th>
                        <th><div className={styles.scrollableHeader}>Nome do Produto</div></th>
                        <th><div className={styles.scrollableHeader}>Fabricante</div></th>
                        <th><div className={styles.scrollableHeader}>Grupo</div></th>
                    </tr>
                </thead>
                <tbody>
                    {products.map((product, index) => (
                        <tr key={index}> {/* Use index for the key */}
                        <td>
                            <input
                            type="checkbox"
                            checked={selectedProducts.includes(product.id)}
                            onChange={() => handleCheckboxChange(product.id)}
                            />
                        </td>
                        <td>{index + 1 + (currentPage - 1) * itemsPerPage}</td>
                        <td>{product.barcode}</td>
                        <td>{product.name}</td>
                        <td>{product.manufacturer}</td>
                        <td>{product.group}</td>
                        </tr>
                    ))}
                </tbody>
            </table>
        </div>
    </div>
    );
};

export default Import;